<div class="radio-toggle" :aria-label="resolvedAriaLabel">
  <button
    v-for="option in options"
    :key="getOptionValue(option)"
    type="button"
    class="radio-toggle__option"
    :class="{
      'radio-toggle__option--active': isActive(option),
      'radio-toggle__option--disabled': isDisabled(option),
    }"
    :aria-pressed="isActive(option)"
    :aria-disabled="isDisabled(option)"
    v-tooltip.bottom="getOptionTooltip(option)"
    @click="selectOption(option)"
  >
    <i v-if="option.icon" :class="option.icon"></i>
    <span>{{ getOptionLabel(option) }}</span>
  </button>
</div>
